import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from '../../shared/button.component';

export default class ControlButtons extends PureComponent {
  static propTypes = {
    readOnly: PropTypes.bool.isRequired,
    canModify: PropTypes.bool.isRequired,

    isTestInProgress: PropTypes.bool.isRequired,
    isSavingInProgress: PropTypes.bool.isRequired,
    isLoadingDataToEdit: PropTypes.bool.isRequired,
    areValuesValid: PropTypes.bool.isRequired,

    onTestClick: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired,
    onEditClick: PropTypes.func.isRequired,
    onSaveClick: PropTypes.func.isRequired,
    onShowInsertQueryModal: PropTypes.func,
  };

  render() {
    const {
      readOnly,
      canModify,

      isTestInProgress,
      isSavingInProgress,
      isLoadingDataToEdit,
      areValuesValid,

      onTestClick,
      onCancelClick,
      onEditClick,
      onSaveClick,
      onShowInsertQueryModal,
    } = this.props;

    return (
      <div className="d-flex flex-row-reverse mt-2">
        {readOnly
          ? null
          : (
            <Button
              type="button"
              kind="primary"
              disabled={isSavingInProgress || isLoadingDataToEdit || !areValuesValid}
              onClick={onSaveClick}
            >
              Save Changes
            </Button>
          )
        }
        {!readOnly || !canModify
          ? null
          : (
            <Button
              type="button"
              kind="primary"
              disabled={isSavingInProgress || isLoadingDataToEdit}
              onClick={onEditClick}
            >
              Edit Query
            </Button>
          )
        }
        <Button
          type="button"
          kind="secondary"
          className="a-mx-10"
          onClick={onCancelClick}
        >
          Cancel
        </Button>
        <Button
          type="button"
          kind="primary"
          disabled={isTestInProgress}
          onClick={onTestClick}
        >
          Test Query
        </Button>

        {
          readOnly && onShowInsertQueryModal
            ? (
              <Button
                type="button"
                kind="primary"
                onClick={onShowInsertQueryModal}
                className="a-mr-10"
              >
                Show insert query
              </Button>
            )
            : null
        }
      </div>
    );
  }
}
